var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnyxLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1076 414.1",
    style: {
      enableBackground: "new 0 0 1076 414.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4736_1_",
    transform: "translate(-364.12 485.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147217_1_",
    d: "M871.7-201.8c-44.7,0-80.9-36.1-81-80.8v-122.3c-0.1-22.5-18.4-40.7-40.9-40.6 c-22.5,0-40.8,18.1-40.9,40.6v181.7c0,11.1-9,20.1-20.1,20.1s-20.1-9-20.1-20.1v-181.7c0-44.5,36.3-80.8,81-80.8s80.9,36.1,81,80.8 v122.3c0.1,22.5,18.4,40.7,40.9,40.6c22.5,0,40.8-18.1,40.9-40.6v-102.5c0-11.1,9-20.1,20.1-20.1l0,0c11.1,0,20.1,9,20.1,20.1 v102.5C952.6-237.9,916.4-201.7,871.7-201.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147218_1_",
    d: "M1150.6-439.7c-7.8-7.8-20.6-7.8-28.4,0l-67.6,67.6L946.9-479.8c-7.8-7.8-20.6-7.8-28.4,0 c-7.8,7.8-7.8,20.6,0,28.4l116,116v113.6c0,11.1,9,20.1,20.1,20.1s20.1-9,20.1-20.1l0,0v-113.6l76-76 C1158.4-419.2,1158.4-431.9,1150.6-439.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147219_1_",
    d: "M506.1-201.8c-78.3,0-142-63.7-142-142s63.7-142,142-142s142,63.7,142,142S584.4-201.8,506.1-201.8  M506.1-445.5c-56.2,0.1-101.7,45.6-101.8,101.8c0.1,56.2,45.6,101.7,101.8,101.8c56.2-0.1,101.7-45.6,101.8-101.8 C607.8-399.9,562.3-445.5,506.1-445.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147220_1_",
    d: "M1353.3-317c-7.8-7.8-20.6-7.8-28.4,0l0,0c-7.8,7.8-7.8,20.5,0,28.4l0,0l81,81 c3.8,3.8,8.9,5.9,14.2,5.9c5.3,0,10.4-2.1,14.2-5.9c7.8-7.8,7.8-20.6,0-28.4L1353.3-317z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147221_1_",
    d: "M1243.1-317l-81,81c-7.8,7.8-7.8,20.6,0,28.4l0,0c3.8,3.8,8.9,5.9,14.2,5.9c5.3,0,10.4-2.1,14.2-5.9 l80.9-80.9c7.8-7.8,7.8-20.6,0-28.4C1263.6-324.8,1250.9-324.8,1243.1-317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147222_1_",
    d: "M1339.1-364.6c5.3,0,10.4-2.1,14.2-5.9l81-81c7.8-7.8,7.8-20.5,0-28.4l0,0c-7.8-7.8-20.5-7.8-28.4,0 l0,0l-81,81c-7.8,7.8-7.8,20.5,0,28.4l0,0C1328.7-366.7,1333.8-364.6,1339.1-364.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147223_1_",
    d: "M1190.5-479.8c-7.8-7.8-20.6-7.8-28.4,0s-7.8,20.6,0,28.4l81,81c3.8,3.8,8.9,5.9,14.2,5.9 c5.3,0,10.4-2.1,14.2-5.9c7.8-7.8,7.8-20.5,0-28.4l0,0L1190.5-479.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147224_1_",
    d: "M1298.2-364c-11.2,0-20.2,9.1-20.2,20.2l0,0c0,11.2,9.1,20.2,20.2,20.2l0,0c11.2,0,20.2-9.1,20.2-20.2 l0,0C1318.4-354.9,1309.4-364,1298.2-364L1298.2-364"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4729_1_",
    transform: "translate(1156.47 -161.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147225_1_",
    d: "M0,69.5V0h10.1v69.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147226_1_",
    d: "M59.1,69.5V41.3c0-8.8-2.6-16.3-13-16.3c-9.6,0-13.7,7.4-13.7,16.2v28.4h-9.8V17.5h9.1V23h0.2 c3.8-5,9.2-7,15.2-7c7.4,0,14.4,2.9,18.4,9.3c2.5,3.9,3.3,8.7,3.3,13.3v30.8L59.1,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147227_1_",
    d: "M94.7,70.9c-2.3,0-4.5-0.4-6.7-1.2c-7.7-2.7-11.7-9-11.7-17.2h9.8c0.4,5.4,3,9.5,8.8,9.5 c4.3,0,7.5-2.6,7.5-7.1c0-10.9-23.8-5.3-23.8-23.7c0-8.9,7.8-15,16.4-15c8.9,0,15.8,6.2,16,15.2h-9.8c-0.5-3.8-2.7-6.3-6.7-6.3 c-3.3,0-6.1,2.1-6.1,5.5c0,4.6,4.5,5.6,8.1,6.8c8.5,2.6,15.7,6.9,15.7,16.9C112.2,64.5,104.7,70.9,94.7,70.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147228_1_",
    d: "M119.9,11.5V0h9.8v11.5H119.9z M119.9,69.5v-52h9.8v52.1L119.9,69.5L119.9,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147229_1_",
    d: "M166.4,90c-11.4,0-21-5.9-25.7-16.4h10.9c3.6,5.1,8.6,7.5,14.8,7.5c11.8,0,18.3-6.5,18.3-18.4h-0.2 c-4.1,5.7-11.1,8.2-18,8.2c-14.9,0-27.8-12.5-27.8-27.5c0-4,1-8,2.8-11.7c4.8-10,14.1-15.6,25.2-15.6c6.4,0,13.6,2.5,17.9,7.4v-6 h9.8v45C194.6,80.1,183.7,90,166.4,90z M173.6,26.4c-2.2-0.9-4.5-1.4-6.9-1.4c-10.1,0.1-18.2,8.4-18,18.5l0,0 c0,9.9,8,18.4,17.9,18.4c7.6,0,13.5-4.2,16.5-11.1c1.1-2.3,1.6-4.7,1.7-7.2C184.8,35.6,181.1,29.3,173.6,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147230_1_",
    d: "M242.8,69.5V41.3c0-8.8-2.6-16.3-13-16.3c-9.6,0-13.7,7.4-13.7,16.2v28.4h-9.8V0h9.8v23h0.2 c3.4-5.1,8.7-7,14.6-7c7.4,0,14.4,2.9,18.4,9.3c2.5,3.9,3.3,8.7,3.3,13.3v30.8L242.8,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147231_1_",
    d: "M275.1,26.4v43.1h-9.8V26.4h-7v-8.9h7V0h9.8v17.5h8.6v8.9H275.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnyxLogoBlack);
export default __webpack_public_path__ + "static/media/ONYX-Logo-Black.eefa38b4072d1928501927c427417f8f.svg";
export { ForwardRef as ReactComponent };